import { Route, Switch, useHistory, useLocation } from 'quartz-routing/react-router';
import { getPortalBasename, PageNotFound, PortalsAppLayout, PortalsAuthGuard } from 'portals-platform-lib';
import TokenExplorer from '../containers/TokenExplorer';
import { ProjectPOC } from '../containers/ProjectPOC';
import { FormExample } from '../containers/FormExample';
import { RouterProvider } from 'quartz-routing';
// @bend-expect quartz-no-create-browser-history
import { createBrowserHistory } from 'quartz-routing/react-router';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AppShell() {
  const history = useHistory();
  const location = useLocation();
  return /*#__PURE__*/_jsx(PortalsAppLayout, {
    history: history,
    currentPathname: location.pathname,
    children: /*#__PURE__*/_jsx(PortalsAuthGuard, {
      children: /*#__PURE__*/_jsxs(Switch, {
        children: [/*#__PURE__*/_jsx(Route, {
          path: "/",
          exact: true,
          children: /*#__PURE__*/_jsx(TokenExplorer, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/token-explorer",
          exact: true,
          children: /*#__PURE__*/_jsx(TokenExplorer, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/projects/:id",
          exact: true,
          children: /*#__PURE__*/_jsx(ProjectPOC, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/projects",
          exact: true,
          children: /*#__PURE__*/_jsx(ProjectPOC, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: "/form-examples",
          exact: true,
          children: /*#__PURE__*/_jsx(FormExample, {})
        }), /*#__PURE__*/_jsx(Route, {
          children: /*#__PURE__*/_jsx(PageNotFound, {})
        })]
      })
    })
  });
}
export const Routes = () => {
  var _getPortalBasename;
  const history = createBrowserHistory({
    basename: (_getPortalBasename = getPortalBasename()) !== null && _getPortalBasename !== void 0 ? _getPortalBasename : '/portals-platform-reference-fe'
  });
  return /*#__PURE__*/_jsx(RouterProvider, {
    history: history,
    children: /*#__PURE__*/_jsx(AppShell, {})
  });
};